import { render, staticRenderFns } from "./CouponDiscountHeader.vue?vue&type=template&id=3e4597bc&scoped=true"
import script from "./CouponDiscountHeader.vue?vue&type=script&lang=js"
export * from "./CouponDiscountHeader.vue?vue&type=script&lang=js"
import style0 from "./CouponDiscountHeader.vue?vue&type=style&index=0&id=3e4597bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4597bc",
  null
  
)

export default component.exports